const ArrowNext = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="12"
            fill="none"
            viewBox="0 0 9 12"
            {...props}
        >
            <path fill="#000" d="M9 6l-9 5.196V.804L9 6z" />
        </svg>
    )
}

export default ArrowNext
